import { useState } from "react";
import { faqsBySlug } from "../../../data/faqs";
import PropTypes from "prop-types";

const FaqSection = ({ slug }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [showCount, setShowCount] = useState(5);

const normalizedSlug = slug?.replace(/^\/|\/$/g, "");
const faqs = faqsBySlug[normalizedSlug] || [];

  const displayedFaqs = faqs.slice(0, showCount);
  const hasMore = faqs.length > showCount;

  const handleLoadMore = () => {
    setShowCount((prev) => prev + 7);
  };

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  if (!faqs.length) return null;

  return (
    <div
      data-section-theme="light"
      className="w-full bg-white font-fira-sans"
      style={{
        borderTop: "1px solid #08090A33",
        borderBottom: "1px solid #08090A33",
      }}
    >
      <div
        className="gutter-x"
        style={{
          borderLeft: "1px solid #08090A33",
          borderRight: "1px solid #08090A33",
        }}
      >
        <div className="px-4 md:pl-[60px] md:pr-[60px] py-16">
          <div className="flex flex-col md:flex-row gap-12">
            {/* Left */}
            <div className="md:w-[35%]">
              <p className="text-black uppercase tracking-[1.75px] mb-4">
                COMMON QUESTIONS
              </p>
              <h2 className="text-black text-[30px] md:text-[38px] font-medium">
                Everything you&apos;re wondering about
              </h2>
            </div>

            {/* Right */}
            <div className="md:w-[65%] space-y-4">
              {displayedFaqs.map((faq, index) => (
                <div
                  key={index}
                  className="border border-[#08090A4D] bg-[#F5F5F5] rounded-[2px]"
                >
                  <button
                    onClick={() => toggleFaq(index)}
                    className="w-full flex justify-between items-center p-6 py-3 text-left"
                  >
                    <span>{faq.question}</span>
                    <span
                      className="text-2xl transition-transform"
                      style={{
                        transform:
                          openIndex === index
                            ? "rotate(45deg)"
                            : "rotate(0deg)",
                      }}
                    >
                      +
                    </span>
                  </button>

                  {openIndex === index && (
                    <div className="px-6 pb-6 pt-2 text-black/70">
                      {faq.answer}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {hasMore && (
            <div className="flex justify-center mt-8">
              <button
                onClick={handleLoadMore}
                className="px-6 py-3 bg-black text-white rounded-[2px]"
              >
                Load More
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

FaqSection.propTypes = {
  slug: PropTypes.string.isRequired,
};
export default FaqSection;
